export default __webpack_public_path__ + "static/media/trade3.9be23d0f.png";